import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { form, TFormCodec } from "../../../shared/src/codecs/types/form";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string, TAnyStringCodec } from "../../../shared/src/codecs/types/string";
import { TAnyUuidCodec, uuid } from "../../../shared/src/codecs/types/uuid";
import { boolean, TBooleanCodec } from "../../../shared/src/codecs/types/boolean";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";

export const ChatsMessageForm: TFormCodec<
    TRequiredCodec<{
        chats_id: TAnyUuidCodec,
        roadblock_id: TAnyUuidCodec,
        note_body: TAnyStringCodec
    }>,
    TEmptyObjectCodec
> = form(
    required({
        chats_id: uuid(),
        roadblock_id: uuid(),
        note_body: string()
    }),
    EmptyObject
);
export type TChatsMessageFormCodec = typeof ChatsMessageForm;
export type TChatsMessageForm = TTypeOfCodec<TChatsMessageFormCodec>;

export const UpdateChatMessageForm: TFormCodec<
    TRequiredCodec<{
        id: TAnyUuidCodec,
        chats_id: TAnyUuidCodec,
        note_body: TAnyStringCodec,
    }>,
    TEmptyObjectCodec
> = form(
    required({
        id: uuid(),
        chats_id: uuid(),
        note_body: string(),
    }),
    EmptyObject
);
export type TUpdateChatMessageFormCodec = typeof UpdateChatMessageForm;
export type TUpdateChatMessageForm = TTypeOfCodec<TUpdateChatMessageFormCodec>;

export const SetChatMessagePinnedForm: TFormCodec<
    TRequiredCodec<{
        id: TAnyUuidCodec,
        chats_id: TAnyUuidCodec,
        pinned: TBooleanCodec,
    }>,
    TEmptyObjectCodec
> = form(
    required({
        id: uuid(),
        chats_id: uuid(),
        pinned: boolean(),
    }),
    EmptyObject
);
export type TSetChatMessagePinnedFormCodec = typeof SetChatMessagePinnedForm;
export type TSetChatMessagePinnedForm = TTypeOfCodec<TSetChatMessagePinnedFormCodec>;


export const ChatCommandActions = [
    "assign" as const,
    "await" as const,
    "add-check-item" as const,
];

export type TChatCommandAction = typeof ChatCommandActions[number];
export type TChatCommandString = `#${TChatCommandAction}:${string}` | `#${TChatCommandAction}`;
export const isAValidChatCommandAction = (action: string) => ChatCommandActions.includes(action as TChatCommandAction);

export type TChatCommand = {
    action: TChatCommandAction;
    target?: string;
}

export const AWAIT_DAYS_MIN = 1;
export const AWAIT_DAYS_MAX = 365;

export const PARK_DAYS_MAX = 5;

export const awaitDaysMaxFor = (isInternal: boolean): number =>
    isInternal ? PARK_DAYS_MAX : AWAIT_DAYS_MAX;

export const parseAwaitDays = (text: string, max: number = AWAIT_DAYS_MAX): number | null => {
    if (!/^\d+$/.test(text)) {
        return null;
    }
    const days = Number(text);
    return days >= AWAIT_DAYS_MIN && days <= max ? days : null;
};